if($('.category-filters').length) {

    let mobileCategoryFiltersButton = $('.mobile-category-filters-toggle'),
        categoryFilterMenu = $('.category-filters-list');

    mobileCategoryFiltersButton.on('click', function() {
        if($(this).hasClass('active')) {
            $(this).removeClass('active');
            categoryFilterMenu.slideUp(200);
        } else {
            $(this).addClass('active');
            categoryFilterMenu.slideDown(200);
        }
    });

}
